module.exports = __webpack_public_path__ + "img/clock-solid.9f0c8b2c.svg";